import getConfig from 'next/config';

export const B2cAndWebFavicons = () => {
    const { publicRuntimeConfig } = getConfig();
    const cdnUrl = publicRuntimeConfig.cdnUrl;
    const faviconsBaseUrl = `${cdnUrl}/favicons`;

    return (
        <>
            <link
                key="b2c-favicon-16x16"
                rel="icon"
                type="image/png"
                sizes="16x16"
                href={`${faviconsBaseUrl}/favicon-16x16.png`}
            />
            <link
                key="b2c-favicon-32x32"
                rel="icon"
                type="image/png"
                sizes="32x32"
                href={`${faviconsBaseUrl}/favicon-32x32.png`}
            />
            <link
                key="b2c-favicon-96x96"
                rel="icon"
                type="image/png"
                sizes="96x96"
                href={`${faviconsBaseUrl}/favicon-96x96.png`}
            />
            <link key="b2c-favicon-ico" rel="icon" href={`${faviconsBaseUrl}/favicon.ico`} sizes="any" />
            <link
                key="b2c-android-icon-36x36"
                rel="icon"
                type="image/png"
                sizes="36x36"
                href={`${faviconsBaseUrl}/android-icon-36x36.png`}
            />
            <link
                key="b2c-android-icon-48x48"
                rel="icon"
                type="image/png"
                sizes="48x48"
                href={`${faviconsBaseUrl}/android-icon-48x48.png`}
            />
            <link
                key="b2c-android-icon-72x72"
                rel="icon"
                type="image/png"
                sizes="72x72"
                href={`${faviconsBaseUrl}/android-icon-72x72.png`}
            />
            <link
                key="b2c-android-icon-96x96"
                rel="icon"
                type="image/png"
                sizes="96x96"
                href={`${faviconsBaseUrl}/android-icon-96x96.png`}
            />
            <link
                key="b2c-android-icon-144x144"
                rel="icon"
                type="image/png"
                sizes="144x144"
                href={`${faviconsBaseUrl}/android-icon-144x144.png`}
            />
            <link
                key="b2c-android-icon-192x192"
                rel="icon"
                type="image/png"
                sizes="192x192"
                href={`${faviconsBaseUrl}/android-icon-192x192.png`}
            />
            <link key="b2c-apple-touch-icon" rel="apple-touch-icon" href={`${faviconsBaseUrl}/apple-touch-icon.png`} />
            <link
                key="b2c-apple-icon-57x57"
                rel="apple-touch-icon"
                sizes="57x57"
                href={`${faviconsBaseUrl}/apple-icon-57x57.png`}
            />
            <link
                key="b2c-apple-icon-60x60"
                rel="apple-touch-icon"
                sizes="60x60"
                href={`${faviconsBaseUrl}/apple-icon-60x60.png`}
            />
            <link
                key="b2c-apple-icon-72x72"
                rel="apple-touch-icon"
                sizes="72x72"
                href={`${faviconsBaseUrl}/apple-icon-72x72.png`}
            />
            <link
                key="b2c-apple-icon-76x76"
                rel="apple-touch-icon"
                sizes="76x76"
                href={`${faviconsBaseUrl}/apple-icon-76x76.png`}
            />
            <link
                key="b2c-apple-icon-114x114"
                rel="apple-touch-icon"
                sizes="114x114"
                href={`${faviconsBaseUrl}/apple-icon-114x114.png`}
            />
            <link
                key="b2c-apple-icon-120x120"
                rel="apple-touch-icon"
                sizes="120x120"
                href={`${faviconsBaseUrl}/apple-icon-120x120.png`}
            />
            <link
                key="b2c-apple-icon-144x144"
                rel="apple-touch-icon"
                sizes="144x144"
                href={`${faviconsBaseUrl}/apple-icon-144x144.png`}
            />
            <link
                key="b2c-apple-icon-152x152"
                rel="apple-touch-icon"
                sizes="152x152"
                href={`${faviconsBaseUrl}/apple-icon-152x152.png`}
            />
            <link
                key="b2c-apple-icon-180x180"
                rel="apple-touch-icon"
                sizes="180x180"
                href={`${faviconsBaseUrl}/apple-icon-180x180.png`}
            />
            <link
                key="b2c-apple-icon-precomposed"
                rel="apple-touch-icon-precomposed"
                href={`${faviconsBaseUrl}/apple-icon-precomposed.png`}
            />
            <link
                key="b2c-safari-pinned-tab"
                rel="mask-icon"
                href={`${faviconsBaseUrl}/safari-pinned-tab.svg`}
                color="#5bbad5"
            />
            <link key="b2c-site-webmanifest" rel="manifest" href={`${faviconsBaseUrl}/site.webmanifest`} />
            <meta
                key="b2c-browserconfig-xml"
                name="msapplication-config"
                content={`${faviconsBaseUrl}/browserconfig.xml`}
            />
            <meta
                key="b2c-mstile-150x150"
                name="msapplication-TileImage"
                content={`${faviconsBaseUrl}/mstile-150x150.png`}
            />
        </>
    );
};
